import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result } from '@digibricks/domains';
import { SectionSummary, FormStatusCheck, Heading, NoneValue } from '../../../core';
import { AxiosApi } from '@digibricks/plugin-axios';
import { ErrorResultHandler } from '@lib/domain-common';
export var FORM_API = 'FORM_API';
export var FormApi = /*#__PURE__*/function (_AxiosApi) {
  _inherits(FormApi, _AxiosApi);

  var _super = _createSuper(FormApi);

  function FormApi(axiosInstance, sectionApiMapper, formApiMapper, formSummaryApiMapper) {
    var _this;

    _classCallCheck(this, FormApi);

    _this = _super.call(this, 'forms', axiosInstance);
    _this.axiosInstance = axiosInstance;
    _this.sectionApiMapper = sectionApiMapper;
    _this.formApiMapper = formApiMapper;
    _this.formSummaryApiMapper = formSummaryApiMapper;
    return _this;
  }

  _createClass(FormApi, [{
    key: "findByIds",
    value: function () {
      var _findByIds = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(formIds) {
        var url, jsonResponse, parsedResponseBody, formStatusCheckList;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                url = "".concat(this.url);
                _context.next = 4;
                return this.axios.get(url, {
                  headers: {
                    Authorization: "Bearer ".concat(localStorage.getItem('access_token'))
                  },
                  params: {
                    formIds: formIds.join(',')
                  }
                });

              case 4:
                jsonResponse = _context.sent;
                parsedResponseBody = jsonResponse.data;
                formStatusCheckList = parsedResponseBody.data.map(function (data) {
                  return FormStatusCheck.fromJson(data);
                });
                return _context.abrupt("return", Result.combineArray(formStatusCheckList));

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", ErrorResultHandler(_context.t0));

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 10]]);
      }));

      function findByIds(_x) {
        return _findByIds.apply(this, arguments);
      }

      return findByIds;
    }()
  }, {
    key: "findById",
    value: function () {
      var _findById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(input) {
        var url, jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                url = "".concat(this.url, "/").concat(input);
                _context2.next = 4;
                return this.axios.get(url);

              case 4:
                jsonResponse = _context2.sent;
                parsedResponseBody = jsonResponse.data;
                return _context2.abrupt("return", Result.ok(this.formApiMapper.toDomain(parsedResponseBody.data)));

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", ErrorResultHandler(_context2.t0));

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 9]]);
      }));

      function findById(_x2) {
        return _findById.apply(this, arguments);
      }

      return findById;
    }()
  }, {
    key: "create",
    value: function () {
      var _create = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(input) {
        var url, jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                url = "".concat(this.url);
                _context3.next = 4;
                return this.axios.post(url, input);

              case 4:
                jsonResponse = _context3.sent;
                parsedResponseBody = jsonResponse.data;
                return _context3.abrupt("return", Result.ok(parsedResponseBody.message));

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](0);
                return _context3.abrupt("return", ErrorResultHandler(_context3.t0));

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 9]]);
      }));

      function create(_x3) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: "import",
    value: function () {
      var _import2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(useCaseInput) {
        var _id, _input, url, jsonResponse, parsedResponseBody;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _id = useCaseInput.id, _input = useCaseInput.input;
                url = "".concat(this.url, "/").concat(_id, "/import");
                _context4.next = 5;
                return this.axios.post(url, _input);

              case 5:
                jsonResponse = _context4.sent;
                parsedResponseBody = jsonResponse.data;
                return _context4.abrupt("return", Result.ok(parsedResponseBody.message));

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](0);
                return _context4.abrupt("return", ErrorResultHandler(_context4.t0));

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 10]]);
      }));

      function _import(_x4) {
        return _import2.apply(this, arguments);
      }

      return _import;
    }()
  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(useCaseInput) {
        var _id2, _input2, url, jsonResponse, parsedResponseBody;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                _id2 = useCaseInput.id, _input2 = useCaseInput.input;
                url = "".concat(this.url, "/").concat(_id2);
                _context5.next = 5;
                return this.axios.patch(url, _input2);

              case 5:
                jsonResponse = _context5.sent;
                parsedResponseBody = jsonResponse.data;
                return _context5.abrupt("return", Result.ok(parsedResponseBody.message));

              case 10:
                _context5.prev = 10;
                _context5.t0 = _context5["catch"](0);
                return _context5.abrupt("return", ErrorResultHandler(_context5.t0));

              case 13:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 10]]);
      }));

      function update(_x5) {
        return _update.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(id) {
        var url, jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                url = "".concat(this.url, "/").concat(id);
                _context6.next = 4;
                return this.axios["delete"](url);

              case 4:
                jsonResponse = _context6.sent;
                parsedResponseBody = jsonResponse.data;
                return _context6.abrupt("return", Result.ok(parsedResponseBody.message));

              case 9:
                _context6.prev = 9;
                _context6.t0 = _context6["catch"](0);
                return _context6.abrupt("return", ErrorResultHandler(_context6.t0));

              case 12:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 9]]);
      }));

      function _delete(_x6) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }, {
    key: "getSectionSummaries",
    value: function () {
      var _getSectionSummaries = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(input) {
        var formId, url, jsonResponse, parsedResponseBody, sections;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                formId = input.formId;
                _context7.prev = 1;
                url = "".concat(this.url, "/").concat(formId, "/section-summary");
                _context7.next = 5;
                return this.axios.get(url);

              case 5:
                jsonResponse = _context7.sent;
                parsedResponseBody = jsonResponse.data;
                sections = parsedResponseBody.data.map(function (data) {
                  return SectionSummary.create(data);
                });
                return _context7.abrupt("return", Result.combineArray(sections));

              case 11:
                _context7.prev = 11;
                _context7.t0 = _context7["catch"](1);
                return _context7.abrupt("return", ErrorResultHandler(_context7.t0));

              case 14:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[1, 11]]);
      }));

      function getSectionSummaries(_x7) {
        return _getSectionSummaries.apply(this, arguments);
      }

      return getSectionSummaries;
    }()
  }, {
    key: "createSection",
    value: function () {
      var _createSection = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(section) {
        var url, payload;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                url = "".concat(this.url, "/").concat(section.formId, "/sections");
                payload = this.sectionApiMapper.fromDomain(section);
                _context8.next = 5;
                return this.axios.post(url, payload);

              case 5:
                return _context8.abrupt("return", Result.ok(section));

              case 8:
                _context8.prev = 8;
                _context8.t0 = _context8["catch"](0);
                return _context8.abrupt("return", ErrorResultHandler(_context8.t0));

              case 11:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[0, 8]]);
      }));

      function createSection(_x8) {
        return _createSection.apply(this, arguments);
      }

      return createSection;
    }()
  }, {
    key: "updateSection",
    value: function () {
      var _updateSection = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(section) {
        var _id3, formId, url, payload;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                _id3 = section.id, formId = section.formId;
                url = "".concat(this.url, "/").concat(formId, "/sections/").concat(_id3);
                payload = this.sectionApiMapper.fromDomain(section);
                _context9.next = 6;
                return this.axios.patch(url, payload);

              case 6:
                return _context9.abrupt("return", Result.ok(section));

              case 9:
                _context9.prev = 9;
                _context9.t0 = _context9["catch"](0);
                return _context9.abrupt("return", ErrorResultHandler(_context9.t0));

              case 12:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[0, 9]]);
      }));

      function updateSection(_x9) {
        return _updateSection.apply(this, arguments);
      }

      return updateSection;
    }()
  }, {
    key: "deleteSection",
    value: function () {
      var _deleteSection = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(useCaseInput) {
        var formId, sectionId, url;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                formId = useCaseInput.formId, sectionId = useCaseInput.sectionId;
                url = "".concat(this.url, "/").concat(formId, "/sections/").concat(sectionId);
                _context10.next = 5;
                return this.axios["delete"](url);

              case 5:
                return _context10.abrupt("return", Result.ok(sectionId));

              case 8:
                _context10.prev = 8;
                _context10.t0 = _context10["catch"](0);
                return _context10.abrupt("return", ErrorResultHandler(_context10.t0));

              case 11:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[0, 8]]);
      }));

      function deleteSection(_x10) {
        return _deleteSection.apply(this, arguments);
      }

      return deleteSection;
    }()
  }, {
    key: "createHeading",
    value: function () {
      var _createHeading = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(data) {
        var request, url, result, heading;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                request = {
                  id: data.id.toString(),
                  title: data.title,
                  sectionId: data.sectionId,
                  description: data.description,
                  nextQuestionId: data.nextQuestionId !== NoneValue ? data.nextQuestionId : undefined,
                  previousHeadingId: data.previousHeadingId !== NoneValue ? data.previousHeadingId : undefined,
                  nextHeadingId: data.nextHeadingId !== NoneValue ? data.nextHeadingId : undefined,
                  previousQuestionId: data.previousQuestionId !== NoneValue ? data.previousQuestionId : undefined,
                  formId: data.formId
                };
                url = "".concat(this.url, "/").concat(data.formId, "/headings");
                _context11.next = 5;
                return this.axios.post(url, request);

              case 5:
                result = _context11.sent;
                heading = Heading.create(_objectSpread({}, result.data.data), result.data.data.id).getValue();
                return _context11.abrupt("return", Result.ok(heading));

              case 10:
                _context11.prev = 10;
                _context11.t0 = _context11["catch"](0);
                return _context11.abrupt("return", ErrorResultHandler(_context11.t0));

              case 13:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[0, 10]]);
      }));

      function createHeading(_x11) {
        return _createHeading.apply(this, arguments);
      }

      return createHeading;
    }()
  }, {
    key: "updateHeading",
    value: function () {
      var _updateHeading = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(input) {
        var data, url, resultOrError, heading;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;
                data = input.data;
                url = "".concat(this.url, "/").concat(data.formId, "/headings/").concat(data.headingId);
                _context12.next = 5;
                return this.axios.patch(url, {
                  title: data.title,
                  description: data.description
                });

              case 5:
                resultOrError = _context12.sent;
                heading = Heading.create(_objectSpread({}, resultOrError.data.data), resultOrError.data.data.id).getValue();
                return _context12.abrupt("return", Result.ok(heading));

              case 10:
                _context12.prev = 10;
                _context12.t0 = _context12["catch"](0);
                return _context12.abrupt("return", ErrorResultHandler(_context12.t0));

              case 13:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this, [[0, 10]]);
      }));

      function updateHeading(_x12) {
        return _updateHeading.apply(this, arguments);
      }

      return updateHeading;
    }()
  }, {
    key: "deleteHeading",
    value: function () {
      var _deleteHeading = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(input) {
        var _id4, formId, url, responseOrError;

        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.prev = 0;
                _id4 = input.id, formId = input.formId;
                url = "".concat(this.url, "/").concat(formId, "/headings/").concat(_id4.toString());
                _context13.next = 5;
                return this.axios["delete"](url);

              case 5:
                responseOrError = _context13.sent;
                return _context13.abrupt("return", Result.ok(responseOrError.data.data.id.value));

              case 9:
                _context13.prev = 9;
                _context13.t0 = _context13["catch"](0);
                return _context13.abrupt("return", ErrorResultHandler(_context13.t0));

              case 12:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this, [[0, 9]]);
      }));

      function deleteHeading(_x13) {
        return _deleteHeading.apply(this, arguments);
      }

      return deleteHeading;
    }()
  }, {
    key: "advancedSearch",
    value: function () {
      var _advancedSearch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(input) {
        var _input$tagIds,
            _parsedResponseBody$d,
            _this2 = this;

        var jsonResponse, parsedResponseBody, forms;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return this.axios.get(this.url, {
                  params: _objectSpread({
                    createdBy: input === null || input === void 0 ? void 0 : input.createdBy,
                    categoryId: input === null || input === void 0 ? void 0 : input.categoryId,
                    nextToken: input === null || input === void 0 ? void 0 : input.nextToken,
                    limit: input === null || input === void 0 ? void 0 : input.limit,
                    search: input === null || input === void 0 ? void 0 : input.search
                  }, (input === null || input === void 0 ? void 0 : (_input$tagIds = input.tagIds) === null || _input$tagIds === void 0 ? void 0 : _input$tagIds.length) > 0 && {
                    tags: input === null || input === void 0 ? void 0 : input.tagIds.join(',')
                  })
                });

              case 2:
                jsonResponse = _context14.sent;
                parsedResponseBody = jsonResponse.data;

                if (parsedResponseBody.data) {
                  _context14.next = 6;
                  break;
                }

                return _context14.abrupt("return", Result.fail(parsedResponseBody.message));

              case 6:
                forms = (_parsedResponseBody$d = parsedResponseBody.data) === null || _parsedResponseBody$d === void 0 ? void 0 : _parsedResponseBody$d.items.map(function (form) {
                  return _this2.formSummaryApiMapper.toDomain(form);
                });
                return _context14.abrupt("return", Result.ok({
                  forms: forms,
                  nextToken: parsedResponseBody.data.nextToken
                }));

              case 8:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function advancedSearch(_x14) {
        return _advancedSearch.apply(this, arguments);
      }

      return advancedSearch;
    }()
  }, {
    key: "clone",
    value: function () {
      var _clone = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(input) {
        var url, request, jsonResponse, parsedResponseBody, clonedForm;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;
                url = "".concat(this.url, "/").concat(input.originalFormId, "/clone");
                request = {
                  id: input.id,
                  type: input.type
                };
                _context15.next = 5;
                return this.axios.post(url, request);

              case 5:
                jsonResponse = _context15.sent;
                parsedResponseBody = jsonResponse.data;

                if (parsedResponseBody.data) {
                  _context15.next = 9;
                  break;
                }

                return _context15.abrupt("return", Result.fail(parsedResponseBody.message));

              case 9:
                clonedForm = this.formApiMapper.toDomain(parsedResponseBody.data);
                return _context15.abrupt("return", Result.ok(clonedForm));

              case 13:
                _context15.prev = 13;
                _context15.t0 = _context15["catch"](0);
                return _context15.abrupt("return", ErrorResultHandler(_context15.t0));

              case 16:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this, [[0, 13]]);
      }));

      function clone(_x15) {
        return _clone.apply(this, arguments);
      }

      return clone;
    }()
  }]);

  return FormApi;
}(AxiosApi);